// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YcXR","label":"styles_label__3j7i-"};